/* eslint-disable no-lone-blocks */
import $ from 'jquery';
$(function () {
	///大小網共用
	//header:滑至一定高度之後，鎖住header
	$(window).scroll(function () {
		if ($(this).scrollTop() > 0) {
			$(".wrapper").addClass("sticky");
		}
		else {
			$(".wrapper").removeClass("sticky");
		}
		//section:滑動後變暗
		$('.section').each(function (i) {
			var bottom_of_object = $(this).offset().top + ($(this).height() / 3);
			var bottom_of_window = $(window).scrollTop() + $(window).height();
			if (bottom_of_window > bottom_of_object) {
				$(this).prev().addClass('effect_dark');
			}
			else {
				$(this).prev().removeClass('effect_dark');
			}
			if ($(window).scrollTop() <= 110) {
				$('#section0').removeClass('effect_dark');
			}
			if ($('.service_index').hasClass('effect_dark')) {
				$('.banner_index').addClass('effect_zindex');
			}
			else {
				{
					$('.banner_index').removeClass('effect_zindex');
				}
			}
		});
	});
	//btn_top:回到上方
	$(window).scroll(function () {
		var sticky = $("header"),
			gotop = $(".btn_top")
		if ($(window).scrollTop() >= 45) {
			sticky.addClass("sticky");
		} else { sticky.removeClass("sticky"); }
		if ($(window).scrollTop() >= 200) {
			gotop.addClass("sticky");
		} else { gotop.removeClass("sticky"); }
	});

	//popup:顯示及隱藏(old)
	// $(".btn_popup").click(function() {
	// 	 $(".popup").hide();
	// 	 var href = $(this).attr('href');
	// 	 $( href ).show();
	// });
	// $(".contain_pop .btn_popup").click(function() {
	// 	 $(".popup").hide();
	// 	 var popData = $(this).attr('data');
	// 	 $( popData ).show();
	// });
	// $(".btn_close").click(function() {
	// 	 $(".popup").hide();
	// });
	//popup:顯示及隱藏
	$(".btn_popup").click(function () {
		$(".popup").hide();
		var href = "#" + $(this).attr('id');
		$(href).show();
	});
	$(".contain_pop .btn_popup").click(function () {
		$(".popup").hide();
		var popData = $(this).attr('data');
		$(popData).show();
	});
	$(".btn_close").click(function () {
		$(".popup").hide();
	});
	//btn_set:選擇狀態
	$(".btn_set").click(function () {
		if ($(this).hasClass("on")) {
			$(this).removeClass("on");
		} else {
			$(this).addClass("on");
		}
	});
	//qa:開闔
	$(".qa_cell .qb_q").click(function () {
		if ($(this).parent().hasClass("active")) {
			$(this).siblings('.qb_a').slideToggle();
			$(this).parent().removeClass("active");
		} else {
			$(this).siblings('.qb_a').slideToggle();
			$(this).parent().addClass("active");
		}
		/*event.preventDefault();*/
	});
	$(".qa_cell .btn_expand").click(function () {
		if ($(this).parent().hasClass("active")) {
			$(this).siblings('.qb_a').slideToggle();
			$(this).parent().removeClass("active");
		} else {
			$(this).siblings('.qb_a').slideToggle();
			$(this).parent().addClass("active");
		}
		// event.preventDefault();
	});
	//web樣式
	if ($(window).width() > 767) {
		//btn_search-搜尋功能:開闔
		$(".btn_search").click(function () {
			if ($(this).hasClass("show")) {
				$('.search_con').slideToggle();
				$(this).removeClass("show");
			} else {
				$('.search_con').slideToggle();
				$(this).addClass("show");
			}
		});
	}
	/////mobile樣式
	if ($(window).width() < 767) {


		//nav:開闔
		$(".opemenu").click(function () {
			if ($(this).hasClass("active")) {
				$("#menu").slideToggle();
				$(this).removeClass("active");
			} else {
				$("#menu").slideToggle();
				$(this).addClass("active");
			}
		});
		//btn_filter-篩選條件:開閉
		$(".btn_filter").click(function () {
			$(".fb_set").show();
		});
		$(".fb_set .btn_main").click(function () {
			$(".fb_set").hide();
		});
		//step_select-下拉選單:切換
		if ($("#step_select").length > 0) {
			$(".sb_m").css({ "display": "none", });
			$("#step01").css({ "display": "block", });
		}
		var step = "";
		var map = { "Step1": "step01", "Step2": "step02", "Step3": "step03", "Step4": "step04", "Step5": "step05", "Step6": "step06", "Step7": "step07", "Step8": "step08", "Step9": "step09", "Step10": "step10" };
		$("#step_select").bind("change", function () {
			var divId = map[this.value];
			document.getElementById("step01").style.display = "none";
			document.getElementById(divId).style.display = "";
			if (step !== "") {
				if (step !== divId) {
					document.getElementById(step).style.display = "none";
				}
			}
			step = divId;
		});
	}
});